var exitContactModal = (function () {
  var csrfToken,
    userShowRecaptcha,
    captchaWidgetId,
    ContactForm = {};

  return {
    init: init,
  };

  function init() {
    //exit intent modal
    var exitModal = document.getElementById('exit-window-modal');

    // Open Exit Modal only on Desktop
    if (exitModal && window.innerWidth > 980) {
      exitModal.classList.contains('exit-window-modal-experiment-show')
        ? WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
            action: exitModalEvents.experiment,
            showModal: true,
          })
        : '';

      loadRecaptchaForDemoModal();
      // if cursor leaves the current window
      document.addEventListener('mouseout', function (e) {
        if (e.clientY < 1) {
          var exitModal = document.getElementById('exit-window-modal');

          if (
            !Cookie.read('closeExitModal-4') &&
            !document.body.classList.contains('tingle-enabled')
          ) {
            userShowRecaptcha = true;
            loadRecaptchaForDemoModal();

            //Load amplitude event
            WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
              action: exitModalEvents.load,
            });

            var exitModalContent = document.getElementById('exit-modal-popup');
            if (exitModalContent) {
              captchaWidgetId = undefined;

              var exitModal = new tingle.modal({
                cssClass: ['exit-window-modal-style-4'],
                onOpen: function () {
                  var tingleModal = document.getElementById('tingle-modal-box');
                  tingleModal.setAttribute('style', 'width:auto !important;');
                  emailFormInit();
                },
                onClose: function () {
                  Cookie.createWithPath('closeExitModal-4', '1', 30);

                  // Close amplitude event
                  WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
                    action: exitModalEvents.close,
                  });

                  exitModal.destroy();
                },
              });
              exitModal.setContent(exitModalContent.innerHTML);
              exitModal.open();
              // load images on modal open
              lazyLoading.show();
            }
          }
        }
      });
    }
  }

  function emailFormInit() {
    ContactForm.formObj = document.querySelector('#tingle-modal-box #exit-modal-form');
    ContactForm.emailField = ContactForm.formObj.querySelector('.exit-window-modal__form--input');
    ContactForm.formsubmit = ContactForm.formObj.querySelector('.exit-window-modal__form--btn');
    ContactForm.sfdcMsgForexitContactFc = ContactForm.formObj.querySelector(
      '[name="sfdc_additional_notes_field_for_exit_intent"]'
    );

    ContactForm.queryType = ContactForm.formObj.querySelector('[name="query_type"]');
    ContactForm.sendEmail = ContactForm.formObj.querySelector('[name="send_email"]');
    ContactForm.utf8 = ContactForm.formObj.querySelector('[name="utf8"]');
    ContactForm.authenticityToken = ContactForm.formObj.querySelector('[name="authenticity_token"]');
    ContactForm.requestType = ContactForm.formObj.querySelector('[name="request_type"]');
    ContactForm.utmCampaign = ContactForm.formObj.querySelector('[name="utm_campaign"]');
    ContactForm.utmAdgroup = ContactForm.formObj.querySelector('[name="utm_adgroup"]');
    ContactForm.gaCid = ContactForm.formObj.querySelector('[name="ga_cid"]');
    ContactForm.gclid = ContactForm.formObj.querySelector('[name="gclid"]');
    ContactForm.utmSource = ContactForm.formObj.querySelector('[name="utm_source"]');
    ContactForm.ctaRef = ContactForm.formObj.querySelector('[name="cta_ref"]');

    //Zoominfo hidden fields value
    ContactForm.title = ContactForm.formObj.querySelector('[name="title"]');
    ContactForm.phoneNumber = ContactForm.formObj.querySelector('[name="phone_number"]');
    ContactForm.mobileNumber = ContactForm.formObj.querySelector('[name="mobile_number"]');
    ContactForm.companyCountry = ContactForm.formObj.querySelector('[name="company_country"]');
    ContactForm.companyWebsite = ContactForm.formObj.querySelector('[name="company_website"]');
    ContactForm.managementLevel = ContactForm.formObj.querySelector('[name="management_level"]');
    ContactForm.companySize = ContactForm.formObj.querySelector('[name="company_size"]');
    ContactForm.jobFunction = ContactForm.formObj.querySelector('[name="job_function"]');
    ContactForm.jobDepartment = ContactForm.formObj.querySelector('[name="job_department"]');
    ContactForm.companyIndustry = ContactForm.formObj.querySelector('[name="company_industry"]');
    ContactForm.secondaryEmailAddress = ContactForm.formObj.querySelector('[name="secondary_email_address"]');
    ContactForm.emailAddress = ContactForm.formObj.querySelector('[name="email_address"]');
    ContactForm.formLinkedInLead = ContactForm.formObj.querySelector('[name="person_linkedin_url"]');
    ContactForm.formEmailValidityCheck = ContactForm.formObj.querySelector('[name="neverbounce_email_status"]');
    ContactForm.formEstimatedRevenue = ContactForm.formObj.querySelector('[name="company_revenue"]');
    ContactForm.formFreeEmail = ContactForm.formObj.querySelector('[name="free_email"]');
    ContactForm.formGenericEmail = ContactForm.formObj.querySelector('[name="generic_email"]');
    ContactForm.formMalformedEmail = ContactForm.formObj.querySelector('[name="malformed_email"]');

    var eTime = setInterval(function () {
      if (captchaWidgetId == undefined) {
        captchaWidgetId = renderCaptchaField();
      }

      if (++intS >= 30 || captchaWidgetId) {
        clearInterval(eTime);
      }
    }, 100);

    // email blur validation
    if (ContactForm.emailField) {
      ContactForm.emailField.addEventListener('blur', function () {
        var that = this,
          emailError = document.querySelector('#tingle-modal-box #email-error');

        //false valid dataset
        that.dataset.notvalid = '0';

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        that.classList.remove('error-border');

        if (that.value.trim().length == 0 || !bsLib.validEmail(that.value.trim())) {
          that.classList.add('error-border');
          emailValidationMsg(that, Messages.salesAndSupportPage.noemail);
        }
      });
    }

    if (ContactForm.formObj) {
      ContactForm.formObj.addEventListener('submit', function (event) {
        event.preventDefault();

        var emailError = document.querySelector('#tingle-modal-box .error-message'),
          emailField = document.querySelector('#tingle-modal-box .exit-window-modal__form--input');
        validEmailBool = true;

        WebEventTracker.logEvent(EDS.webEvents, exitModalEvents.interact, {
          action: 'submit',
          showModal: true,
        })

        if (emailField) {
          if (emailError) {
            emailError.remove();
          }
          emailField.classList.remove('error-border');

          if (
            ContactForm.emailField.value.trim().length == 0 ||
            !bsLib.validEmail(ContactForm.emailField.value.trim())
          ) {
            validEmailBool = false;
            emailField.classList.add('error-border');
            emailValidationMsg(ContactForm.emailField, Messages.salesAndSupportPage.noemail);
          }

          if (validEmailBool) {
            //disabled
            ContactForm.formsubmit.setAttribute('disabled', 'disabled');
            ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btndisabled;

            // corporate email validation check
            var bstackAPI =
                bsLib.railsHost() +
                '/marketing_api/check_email_validation?email=' +
                encodeURIComponent(ContactForm.emailField.value),
              emailErrorMsg,
              neverBounceValidation =
                ContactForm.emailField.dataset.corporateCheckNeverbounce !== undefined &&
                ContactForm.emailField.dataset.corporateCheckNeverbounce === '1'; // Check if never bounce corporate email validation is required

            if (
              ContactForm.emailField.dataset.corporateCheck !== undefined &&
              ContactForm.emailField.dataset.corporateCheck === '1'
            ) {
              bstackAPI = neverBounceValidation
                ? bstackAPI + '&source=paid_ads&check_never_bounce=' + neverBounceValidation
                : bstackAPI + '&source=paid_ads';
              emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail;
            } else {
              emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
            }

            bsLib.ajax(
              'GET',
              bstackAPI,
              {},
              true,
              {
                'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
              },
              function (data) {
                if (data.readyState === 4) {
                  var dataRequest = bsLib.JSONParse(data.response);

                  if (dataRequest.valid === false) {
                    //remove disable
                    if (ContactForm.formsubmit) {
                      ContactForm.formsubmit.removeAttribute('disabled');
                      ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btntext;
                    }
                    emailField.dataset.notvalid = '1';
                    emailField.classList.add('error-border');
                    if (emailField.parentNode.getElementsByClassName('error-message').length === 0) {
                      emailValidationMsg(emailField, emailErrorMsg);
                    }
                  } else {
                    if (grecaptcha !== 'undefined') {
                      if (userShowRecaptcha) {
                        grecaptcha.execute(captchaWidgetId);
                      } else {
                        contactFormSubmit(false);
                      }
                    }
                  }
                }
              },
              function () {}
            );
          }
        }

        return false;
      });
    }
  }
  function emailValidationMsg(emailEle, emailMsg) {
    emailEle.insertAdjacentHTML(
      'afterend',
      '<span class="error-message" id="email-error">' +
        (emailEle.value.trim().length == 0 ? emailMsg : 'Please share valid Business Email') +
        '</span>'
    );
  }
  function contactFormSubmit(checkPromise) {
    if (checkPromise) {
      return new Promise(function (resolve, reject) {
        ContactForm.formsubmit.setAttribute('disabled', 'disabled');
        ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btndisabled;

        var emailExtension = ContactForm.emailField.value,
          emailStr = emailExtension.split('@'),
          finalDomain = emailStr[emailStr.length - 1].split('.'),
          firstName = emailExtension.split('@')[0];

        var dataPayload = {
          name: firstName,
          email: ContactForm.emailField.value,
          query_type: ContactForm.queryType.value,
          message: ContactForm.sfdcMsgForexitContactFc.value,
          company: finalDomain[0],
          send_email: ContactForm.sendEmail.value,
          authenticity_token: ContactForm.authenticityToken.value,
          utf8: ContactForm.utf8.value,
          request_type: ContactForm.requestType.value,
          utm_campaign: ContactForm.utmCampaign.value,
          utm_adgroup: ContactForm.utmAdgroup.value,
          ga_cid: ContactForm.gaCid.value,
          gclid: ContactForm.gclid.value,
          utm_source: ContactForm.utmSource.value,
          ref: popUpCSFOptions.vwoShow
            ? window.innerWidth < 980 && popUpCSFOptions.ref != ''
              ? popUpCSFOptions.ref + '_Mobile'
              : popUpCSFOptions.ref
            : '',
          enterprise_pricing_ref: 'true',
          page_url: window.location.href,
          source: 'wp_form',
          title: ContactForm.title ? ContactForm.title.value : '',
          job_title: ContactForm.jobTitle ? ContactForm.jobTitle.value : '',
          country: ContactForm.country ? ContactForm.country.value : '',
          phone_number: ContactForm.dgPhoneNumber
            ? ContactForm.dgPhoneNumber.value
            : ContactForm.phoneNumber
            ? ContactForm.phoneNumber.value
            : '',
          mobile_number: ContactForm.mobileNumber ? ContactForm.mobileNumber.value : '',
          company_country: ContactForm.companyCountry ? ContactForm.companyCountry.value : '',
          company_website: ContactForm.companyWebsite ? ContactForm.companyWebsite.value : '',
          management_level: ContactForm.managementLevel ? ContactForm.managementLevel.value : '',
          company_size: ContactForm.companySize ? ContactForm.companySize.value : '',
          job_function: ContactForm.jobFunction ? ContactForm.jobFunction.value : '',
          job_department: ContactForm.jobDepartment ? ContactForm.jobDepartment.value : '',
          company_industry: ContactForm.companyIndustry ? ContactForm.companyIndustry.value : '',
          secondary_email_address: ContactForm.secondaryEmailAddress ? ContactForm.secondaryEmailAddress.value : '',
          email_address: ContactForm.emailAddress ? ContactForm.emailAddress.value : '',
          person_linkedin_url: ContactForm.formLinkedInLead ? ContactForm.formLinkedInLead.value : '',
          neverbounce_email_status: ContactForm.formEmailValidityCheck ? ContactForm.formEmailValidityCheck.value : '',
          company_revenue: ContactForm.formEstimatedRevenue ? ContactForm.formEstimatedRevenue.value : '',
          free_email: ContactForm.formFreeEmail ? ContactForm.formFreeEmail.value : '',
          generic_email: ContactForm.formGenericEmail ? ContactForm.formGenericEmail.value : '',
          malformed_email: ContactForm.formMalformedEmail ? ContactForm.formMalformedEmail.value : '',
          web_utm_source: 'dg-exit-modal-demo-form-submit',
          previous_page_url: document.referrer !== '' ? document.referrer : 'organic',
        };

        dataPayload['lead_source'] = 'Demo Request';

        if (typeof grecaptcha === 'undefined') {
          reject();
        }

        var grecaptchaResponse = grecaptcha.getResponse(captchaWidgetId);
        if (!grecaptchaResponse) {
          new bsAlert({
            alertType: 'error',
            timeout: 5000,
            text: Messages.salesAndSupportPage.noRecaptcha,
          });

          if (ContactForm.formsubmit) {
            ContactForm.formsubmit.removeAttribute('disabled');
            ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btntext;
          }

          reject();
        }

        dataPayload['g-recaptcha-response'] = grecaptchaResponse;
        dataPayload['check_email_domain'] = true;

        // xhr request for sending form data
        bsLib.ajax(
          'POST',
          bsLib.railsHost() + '/contact',
          //Form Data
          dataPayload,
          true,
          //Form Header
          {
            'X-CSRF-Token': csrfToken,
            'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', // Setting content type.
          },
          //Form Success
          function (data) {
            if (data.readyState === 4) {
              var dataRequest = bsLib.JSONParse(data.response);
              if (dataRequest.success === true) {
                _logFormSubmit('FormSubmitSuccess');
                
                Cookie.createWithPath('closeExitModal-4', '1', 30);

                resolve();
              } else {
                if (dataRequest.field == 'business_email') {
                  ContactForm.emailField.classList.add('error-border');
                  if (ContactForm.emailField.parentNode.getElementsByClassName('error-message').length === 0) {
                    ContactForm.emailField.insertAdjacentHTML(
                      'afterend',
                      '<span class="error-message" id= "email-error' +
                        ContactForm.uniqueID +
                        '">' +
                        dataRequest.message +
                        '</span>'
                    );
                  }
                  if (ContactForm.formsubmit) {
                    ContactForm.formsubmit.removeAttribute('disabled');
                    ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btntext;
                  }
                  grecaptcha.reset(captchaWidgetId);
                  checkEmailValidation = false;
                } else {
                  if (typeof dataRequest.message !== 'undefined') {
                    new bsAlert({
                      alertType: 'error',
                      timeout: 5000,
                      text: dataRequest.message,
                    });
                    checkEmailValidation = true;
                  }
                }
                _logFormSubmit('FormSubmitError');

                reject();
              }
            }
          },
          //Form Error
          function () {
            _logFormSubmit('FormSubmitError');
            reject();
          }
        );
      });
    } else {
      ContactForm.formsubmit.setAttribute('disabled', 'disabled');
      ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btndisabled;

      var emailExtension = ContactForm.emailField.value,
        emailStr = emailExtension.split('@'),
        finalDomain = emailStr[emailStr.length - 1].split('.'),
        firstName = emailExtension.split('@')[0];

      var dataPayload = {
        name: firstName,
        email: ContactForm.emailField.value,
        query_type: ContactForm.queryType.value,
        message: ContactForm.sfdcMsgForExitIntendFc.value,
        company: finalDomain[0],
        send_email: ContactForm.sendEmail.value,
        authenticity_token: ContactForm.authenticityToken.value,
        utf8: ContactForm.utf8.value,
        request_type: ContactForm.requestType.value,
        utm_campaign: ContactForm.utmCampaign.value,
        utm_adgroup: ContactForm.utmAdgroup.value,
        ga_cid: ContactForm.gaCid.value,
        gclid: ContactForm.gclid.value,
        utm_source: ContactForm.utmSource.value,
        ref: popUpCSFOptions.vwoShow
          ? window.innerWidth < 980 && popUpCSFOptions.ref != ''
            ? popUpCSFOptions.ref + '_Mobile'
            : popUpCSFOptions.ref
          : '',
        enterprise_pricing_ref: 'true',
        page_url: window.location.href,
        cta_ref: refPropVal ? refPropVal : ContactForm.ctaRef.value,
        source: 'wp_form',
        title: ContactForm.title ? ContactForm.title.value : '',
        job_title: ContactForm.jobTitle ? ContactForm.jobTitle.value : '',
        country: ContactForm.country ? ContactForm.country.value : '',
        phone_number: ContactForm.dgPhoneNumber
          ? ContactForm.dgPhoneNumber.value
          : ContactForm.phoneNumber
          ? ContactForm.phoneNumber.value
          : '',
        mobile_number: ContactForm.mobileNumber ? ContactForm.mobileNumber.value : '',
        company_country: ContactForm.companyCountry ? ContactForm.companyCountry.value : '',
        company_website: ContactForm.companyWebsite ? ContactForm.companyWebsite.value : '',
        management_level: ContactForm.managementLevel ? ContactForm.managementLevel.value : '',
        company_size: ContactForm.companySize ? ContactForm.companySize.value : '',
        job_function: ContactForm.jobFunction ? ContactForm.jobFunction.value : '',
        job_department: ContactForm.jobDepartment ? ContactForm.jobDepartment.value : '',
        company_industry: ContactForm.companyIndustry ? ContactForm.companyIndustry.value : '',
        secondary_email_address: ContactForm.secondaryEmailAddress ? ContactForm.secondaryEmailAddress.value : '',
        email_address: ContactForm.emailAddress ? ContactForm.emailAddress.value : '',
        person_linkedin_url: ContactForm.formLinkedInLead ? ContactForm.formLinkedInLead.value : '',
        neverbounce_email_status: ContactForm.formEmailValidityCheck ? ContactForm.formEmailValidityCheck.value : '',
        company_revenue: ContactForm.formEstimatedRevenue ? ContactForm.formEstimatedRevenue.value : '',
        free_email: ContactForm.formFreeEmail ? ContactForm.formFreeEmail.value : '',
        generic_email: ContactForm.formGenericEmail ? ContactForm.formGenericEmail.value : '',
        malformed_email: ContactForm.formMalformedEmail ? ContactForm.formMalformedEmail.value : '',
        // web_utm_source: sourcePropVal ? sourcePropVal : '',
        previous_page_url: document.referrer !== '' ? document.referrer : 'organic',
        web_utm_source: 'dg-exit-modal-demo-form-submit',
      };

      dataPayload['g-recaptcha-response'] = grecaptchaResponse;
      dataPayload['check_email_domain'] = true;
      dataPayload['lead_source'] = 'Demo Request';

      // xhr request for sending form data
      bsLib.ajax(
        'POST',
        bsLib.railsHost() + '/contact',
        //Form Data
        dataPayload,
        true,
        //Form Header
        {
          'X-CSRF-Token': csrfToken,
          'content-type': 'application/x-www-form-urlencoded; charset=UTF-8', // Setting content type.
        },
        //Form Success
        function (data) {
          if (data.readyState === 4) {
            var dataRequest = bsLib.JSONParse(data.response);
            if (dataRequest.success === true) {
              _logFormSubmit('FormSubmitSuccess');
            } else {
              if (dataRequest.field == 'business_email') {
                ContactForm.emailField.classList.add('error-border');
                if (ContactForm.emailField.parentNode.getElementsByClassName('error-message').length === 0) {
                  ContactForm.emailField.insertAdjacentHTML(
                    'afterend',
                    '<span class="error-message" id= "email-error' +
                      ContactForm.uniqueID +
                      '">' +
                      dataRequest.message +
                      '</span>'
                  );
                }
                if (ContactForm.formsubmit) {
                  ContactForm.formsubmit.removeAttribute('disabled');
                  ContactForm.formsubmit.value = ContactForm.formsubmit.dataset.btntext;
                }
                grecaptcha.reset(captchaWidgetId);
              } else {
                if (typeof dataRequest.message !== 'undefined') {
                  new bsAlert({
                    alertType: 'error',
                    timeout: 5000,
                    text: dataRequest.message,
                  });
                }
              }
              _logFormSubmit('FormSubmitError');
            }
          }
        },
        //Form Error
        function () {
          _logFormSubmit('FormSubmitError');
        }
      );
    }
  }
  function _logFormSubmit(event) {
    if (event === 'FormSubmitSuccess') {
      var queryVal = document.querySelector('#tingle-modal-box .exit-window-modal__main'),
        successMsg = document.querySelector('#tingle-modal-box .exit-window-modal__success');
      if (queryVal && successMsg) {
        queryVal.style.display = 'none';
        successMsg.style.display = 'block';
      }
    }

    if (typeof ga !== 'undefined') {
      ga('browserstack.send', 'event', {
        eventCategory: 'Contact',
        eventAction: 'CtaClick',
        eventLabel: 'Submit',
        eventValue: queryVal,
      });
    }
  }
  function setCSRFToken() {
    bsLib.ajax(
      'GET',
      bsLib.railsHost() + '/user/token.json',
      {},
      true,
      {},
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            authenticityToken = document.querySelectorAll('input[name="authenticity_token"]');
          for (var i = 0; i < authenticityToken.length; i++) {
            authenticityToken[i].value = dataRequest.csrf_token;
          }
          csrfToken = dataRequest.csrf_token;
          csrf_token = csrfToken;
        }
      },
      // Custom Error message for user token.
      function () {
        return Messages.salesAndSupportPage.invalidUserToken;
      }
    );
  }

  function loadRecaptchaForDemoModal() {
    var captchaFieldJS = document.getElementById('recaptcha-js');
    if (!captchaFieldJS && typeof grecaptcha === 'undefined') {
      var scriptElm = document.createElement('script');
      scriptElm.setAttribute('id', 'recaptcha-js');
      scriptElm.setAttribute('type', 'text/javascript');
      scriptElm.setAttribute('src', 'https://www.google.com/recaptcha/api.js?ver=1.0');
      scriptElm.setAttribute('defer', 'defer');
      document.body.appendChild(scriptElm);
    }

    //csrfToken
    if (typeof csrf_token !== 'undefined') {
      csrfToken = csrf_token;
    } else if (!csrfToken) {
      setCSRFToken();
    }
  }

  function renderCaptchaField() {
    //remove captcha
    var captchaWidget,
      modalTingle = document.getElementById('tingle-modal-box'),
      captchaFieldShow = document.querySelector('.g-recaptcha.show'),
      captchaField = document.getElementById('contactformExitIntendCSFInvisibleV1');

    //remove all grecaptcha from dom
    if (captchaFieldShow && typeof grecaptcha !== 'undefined') {
      if (captchaFieldShow.innerHTML !== '') {
        captchaFieldShow.innerHTML = '';
      }
    }
    //recaptcha render from JS
    if (
      typeof grecaptcha !== 'undefined' &&
      typeof grecaptcha.ready !== 'undefined' &&
      captchaField.childNodes.length === 0
    ) {
      grecaptcha.ready(function () {
        if (!modalTingle.hasAttribute('data-g-widget-id')) {
          captchaWidget = grecaptcha.render(captchaField, {
            sitekey: captchaField.dataset.sitekey,
            theme: 'light',
            badge: 'bottomleft',
            size: 'invisible',
            callback: function () {
              //recaptcha callback
              return contactFormSubmit(true);
            },
          });

          modalTingle.dataset.gWidgetId = captchaWidget;
        }
      });
    } else if (typeof grecaptcha !== 'undefined' && captchaField.childNodes.length >= 0) {
      captchaWidget = modalTingle.dataset.gWidgetId;
    }

    return captchaWidget;
  }
})();

exitContactModal.init();
